export default {
      id: "correction-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#correction",
      toString: function () {
        return this.url;
      }
    }